export enum GLOBLE_KEY {
    compare = 'compare',
    nafath = 'nafathRequest',
    contactRequest = 'AddContactRequest'
}